import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error"
}

import axios from 'axios'
import isNil from 'lodash/isNil'
import { ref } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import FormCheckBox from '@/components/common/FormCheckBox.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { BowlerEditableData } from '@/store/bowler-app/bowler.types'

interface BowlerEditableInfoFormData {
  email: string
  phone_number: string
  street: string
  postcode: string
  city: string
  country: string
  is_marketing_permitted: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerEditableInfoForm',
  props: {
  initialData: {
    type: Object,
    required: true,
  },
},
  emits: ['dismiss', 'success'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const bowler = useBowlerStore()

const formData = ref<BowlerEditableData>({
  email: props.initialData?.['email'] ?? '',
  phone_number: props.initialData?.['phoneNumber'] ?? '',
  street: props.initialData?.['streetAddress'] ?? '',
  postcode: props.initialData?.['postalCode'] ?? '',
  city: props.initialData?.['city'] ?? '',
  country: props.initialData?.['country'] ?? '',
  is_marketing_permitted: props.initialData?.['isMarketingPermitted'] ?? false,
})

const formError = ref<BowlerEditableInfoFormData | { detail: string } | null>()
const isLoading = ref<boolean>(false)

const submit = async (): Promise<void> => {
  isLoading.value = true
  formError.value = null

  try {
    if (!isNil(bowler.id)) {
      await bowler.update(String(bowler.id), formData.value)
      emit('success')
    }
    emit('dismiss')
  } catch (e) {
    console.log(e)

    formError.value = axios.isAxiosError(e)
      ? e.response?.data ?? {}
      : { detail: e as string }

    console.group('Failed updating bowler data')
    console.error(formError.value)
    console.groupEnd()
  }

  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "bowler-contact-info-edit-form",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createVNode(FormTextInput, {
      modelValue: formData.value.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
      name: "email",
      type: "email",
      label: _ctx.$t('field-labels.email'),
      "error-label": formError.value?.email,
      "is-disabled": "",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "error-label"]),
    _createVNode(FormTextInput, {
      modelValue: formData.value.phone_number,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone_number) = $event)),
      name: "phoneNumber",
      type: "text",
      label: _ctx.$t('field-labels.phone'),
      "error-label": formError.value?.phone_number,
      "is-required": ""
    }, null, 8, ["modelValue", "label", "error-label"]),
    _createVNode(FormTextInput, {
      modelValue: formData.value.street,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.street) = $event)),
      name: "streetAddress",
      type: "text",
      label: _ctx.$t('field-labels.street-address'),
      "is-required": ""
    }, null, 8, ["modelValue", "label"]),
    _createVNode(FormTextInput, {
      modelValue: formData.value.postcode,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.postcode) = $event)),
      name: "postalCode",
      type: "text",
      label: _ctx.$t('field-labels.postal-code'),
      "error-label": formError.value?.postcode,
      "is-required": ""
    }, null, 8, ["modelValue", "label", "error-label"]),
    _createVNode(FormTextInput, {
      modelValue: formData.value.city,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.city) = $event)),
      name: "city",
      type: "text",
      label: _ctx.$t('field-labels.city'),
      "error-label": formError.value?.city,
      "is-required": ""
    }, null, 8, ["modelValue", "label", "error-label"]),
    _createVNode(FormCheckBox, {
      modelValue: formData.value.is_marketing_permitted,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.is_marketing_permitted) = $event)),
      name: "is_marketing_permitted",
      label: _ctx.$t('field-labels.is-marketing-permitted'),
      "error-label": formError.value?.is_marketing_permitted
    }, null, 8, ["modelValue", "label", "error-label"]),
    (formError.value?.['detail'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(formError.value['detail']), 1))
      : _createCommentVNode("", true),
    _createVNode(FormButtonGroup, null, {
      default: _withCtx(() => [
        _createVNode(FormButton, { "is-busy": isLoading.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.save')), 1)
          ]),
          _: 1
        }, 8, ["is-busy"]),
        _createVNode(FormButton, {
          "is-disabled": isLoading.value,
          "is-secondary": "",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('dismiss')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.cancel')), 1)
          ]),
          _: 1
        }, 8, ["is-disabled"])
      ]),
      _: 1
    })
  ], 32))
}
}

})